/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1UserState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_USER_STATE_ENTITY_NAME = 'ixm.userauth.v1.User';
export const ixmUserauthV1UserStateEntity = new schema.Entity<IxmUserauthV1UserState>(IXM_USERAUTH_V1_USER_STATE_ENTITY_NAME, {}, { idAttribute: 'userId' });

